import React, { useContext, useState } from 'react'
import ModalTest from '../../../BaseModal'
import { ContainerOfModal } from '../../../styles/modal-style'
import axios from '../../../../config/axios'
import { FeedbackContext } from '../../../../contexts/FeedbackContext'
import LoadingComponent from '../../../LoadingComponent'

interface propsType {
  setModalActive:React.Dispatch<React.SetStateAction<number | null>>
  id:number
  setRefresh:React.Dispatch<React.SetStateAction<boolean>>
}

const ConfirmModal:React.FC<propsType> = ({setModalActive, id, setRefresh}) => {
  const [ isLoading, setIsLoading ] = useState<boolean>(false)
  const { setFeedback } = useContext(FeedbackContext)

  const handleRevert = async() => {
    setIsLoading(true)
    try {
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/pcp/revert-movement`, {id: Number(id)})
      if(response.data) {
        setModalActive(null)
        setRefresh(prev => !prev)
      }
    } catch (error) {
      console.error(error)
      setFeedback({
        isOpen:true,
        message:'Falha ao reverter a OP',
        statusOk:false
      })
    } finally {
      setIsLoading(false)
    }
  }
  
  return (
    <ModalTest>
      <ContainerOfModal width='25%'>
        <h2>Deseja realmente reverter a OP?</h2>
        <p>Essa ação não poderá ser desfeita.</p>
        <div style={{
          display: 'flex',
          gap: '1rem',
          justifyContent: 'flex-end',
          marginTop: '2rem'
        }}>
          <button
            onClick={() => setModalActive(null)}
            style={{
              padding: '0.5rem 1rem',
              border: '1px solid #ddd',
              background: 'transparent',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >Cancelar</button>
          <button
            onClick={handleRevert}
            style={{
              padding: '0.5rem 1rem', 
              border: 'none',
              background: '#0090D3',
              color: 'white',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >Confirmar</button>
        </div>
      </ContainerOfModal>
      {isLoading && <LoadingComponent />}
    </ModalTest>
  )
}

export default ConfirmModal
